import React from "react";
import { Helmet } from "react-helmet-async";

const LoveSmarterBook = () => {
  return (
    <>
      <Helmet>
        <title>Love Smarter, Not Harder - Interactive Book | Fund Life</title>
        <meta
          name="description"
          content="Read Love Smarter, Not Harder® — a practical, faith-centered guide to building healthy relationships. Explore the full interactive flipbook online."
        />
      </Helmet>
      <div style={{ paddingTop: "120px" }}>
        <div className="container-fluid px-2 px-md-4" style={{ maxWidth: "1500px" }}>
          <div
            className="text-center my-4 book-header-container"
            style={{ marginTop: "24px", marginBottom: "28px" }}
          >
            <h1
              className="display-3 fw-bold"
              style={{ color: "#1a1525" }}
            >
              Love Smarter, Not Harder
            </h1>
            {/* <p
              className="lead text-muted fst-italic fw-semibold"
              style={{ fontStyle: "italic", fontWeight: 600 }}
            >
              Ten Rules for Following Your Heart Without Losing Your Head.
            </p> */}
          </div>

          {/* Interactive Heyzine Flipbook */}
          <div className="my-4">
            <iframe
              allowFullScreen={true}
              allow="autoplay; fullscreen; clipboard-write"
              scrolling="no"
              loading="lazy"
              className="fp-iframe"
              src="https://heyzine.com/flip-book/534df389ad.html"
              style={{
                border: "1px solid lightgray",
                width: "100%",
                height: "600px",
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
              }}
              title="Love Smarter, Not Harder Flipbook"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoveSmarterBook;
